const API_TIMEOUT: number = 2000

export const apiTimeout: Promise<undefined> = new Promise((resolve) => {
  setTimeout(() => {
    resolve(undefined)
  }, API_TIMEOUT)
})
